var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ms-app ms-app-colors",attrs:{"id":"app"}},[_c('CssSwitcher'),_vm._v(" "),(_vm.item)?_c('StreamX',{attrs:{"itemId":1000,"item":_vm.item,"depth":0,"loadItems":true,"loadHtmls":true,"baseUrl":"stream"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.notices),function(notice){return _c('Notice',{directives:[{name:"show",rawName:"v-show",value:(_vm.notices),expression:"notices"}],key:notice,attrs:{"notice":notice}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e9915f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 29
// module chunks = 0